import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute, NavigationEnd, RouterOutlet, RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { filter } from 'rxjs/operators';
import { TabsModule } from 'primeng/tabs';
import { MenubarModule } from 'primeng/menubar';
import { CommonModule } from '@angular/common';
import { SearchMode, SearchService } from '@/services/api/search.service';

@Component({
    selector: 'app-bank-settings',
    imports: [
      RouterOutlet,
      CommonModule, MenubarModule, TabsModule, RouterModule
    ],
    template: `
      <div class="w-full card p-3 border-round">
    <p-tabs value="assemblies">
    <p-tablist>
        @for(tab of tabs; track tab.route){
            <p-tab [value]="tab.route" [routerLink]="tab.route" class="flex items-center !gap-2 text-inherit">
                <i [class]="tab.icon"></i>
                <span>{{ tab.label }}</span>
            </p-tab>
        }
    </p-tablist>
</p-tabs>

    <router-outlet></router-outlet>
  </div>
  `,
})
export class BankSettingsComponent implements OnDestroy {
  activeItem: MenuItem | undefined;
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private titleService = inject(Title);
  private searchService = inject(SearchService);

  tabs = [
    { route: 'lendercontacts', label: 'Lenders', icon: 'pi pi-home' },
    { route: 'drawschedules', label: 'Draw Schedules', icon: 'pi pi-chart-line' }
];

  constructor() {
    this.searchService.setSearchMode(SearchMode.BANKS);
    this.titleService.setTitle('Landmark Ops - Bank Settings');
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      const currentRoute = this.route.firstChild?.snapshot.url[0]?.path;
    });
  }

  onActiveItemChange(event: any) {
    if (event && event.value) {
    this.activeItem = event.value;
    this.router.navigate([this.activeItem?.routerLink], { relativeTo: this.route });
  }
}

ngOnDestroy() {
  this.searchService.setSearchMode(SearchMode.ALL);
}

}